import React from 'react';
import { SubmitButton } from './styles';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';

interface ShareSubmitButtonProps {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
}

const ShareSubmitButton: React.FC<ShareSubmitButtonProps> = ({
  disabled,
  loading,
  onClick,
  style,
}) => {
  const { t } = useTranslation();

  return (
    <SubmitButton disabled={disabled} onClick={onClick} style={style}>
      {loading ? (
        <CircularProgress size={20} color={'inherit'} />
      ) : (
        t('공유하기')
      )}
    </SubmitButton>
  );
};

export default ShareSubmitButton;
